

import api from '../index';

export const GetCountryDetailsApi = () => api.post('countrycode');